module.exports = __webpack_public_path__ + "static/media/20.84835d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/20.png
// module id = 802
// module chunks = 0